import { defineExperiment } from '~/utils/experiments/defineExperiment';

/**
 * The experiments the app runs, one definition each. A definition is read through
 * `useExperiment`, never through `getFlag`: see `docs/system/feature-flags.md`, "Experiments".
 */

/**
 * What a ghost is offered at the end of a learning asset (CP-11944). Control is today's single "Save
 * progress" button; the other arms add "Keep learning", in second place or in first.
 */
export const GHOST_COMPLETION_EXPERIMENT = defineExperiment({
  flag: 'ghost-completion-keep-learning-enabled',
  arms: ['control', 'save-primary', 'learn-primary'],
  control: 'control',
});
